import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {DEFAULT_CACHE_TIME} from '@di-shared/const';

export default function useCapitalTerms() {
  const {data: financialTerms} = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.financialManagementController.getFinancialTerms)],
    queryFn: () => diApi.financialManagementController.getFinancialTerms(),
    select: (data) => data.data?.financialTerms || [],
    ...DEFAULT_CACHE_TIME,
  });

  function getTermsDetail(termsId: string) {
    const terms = financialTerms.find((terms) => terms.termsId === termsId);
    if (!terms) {
      return null;
    }

    return terms;
  }

  return {
    financialTerms,
    getTermsDetail,
  };
}
